const DeliveryForm = ({
  nombre,
  setNombre,
  correoElectronico,
  setCorreoElectronico,
  direccion,
  setDireccion,
  telefono,
  setTelefono,
  instrucciones,
  setInstrucciones,
  onSubmit
}) => (
  <div className="card shadow-sm border-0 rounded-3 p-4">
    <h4 className="mb-4 fw-bold text-primary">Información de entrega</h4>
    
    <form onSubmit={onSubmit}>
      {[
        { label: 'Nombre completo', value: nombre, setter: setNombre, type: 'text', placeholder: 'Juan Pérez' },
        { label: 'Correo electrónico', value: correoElectronico, setter: setCorreoElectronico, type: 'email', placeholder: 'micorreo@correo.com' },
        { label: 'Dirección', value: direccion, setter: setDireccion, type: 'text', placeholder: 'Av. Siempre Viva 123' },
        { label: 'Teléfono', value: telefono, setter: setTelefono, type: 'tel', placeholder: '999 999 999' },
      ].map((input, i) => (
        <div key={i} className="mb-3">
          <label className="form-label fw-semibold">{input.label}</label>
          <input
            type={input.type}
            className="form-control form-control-lg rounded-3"
            required
            placeholder={input.placeholder}
            value={input.value}
            onChange={(e) => { input.setter(e.target.value); e.target.setCustomValidity(''); }}
            onInvalid={(e) => e.target.setCustomValidity('Por favor, complete este campo.')}
          />
        </div>
      ))}

      <div className="mb-3">
        <label className="form-label fw-semibold">Instrucciones adicionales</label>
        <textarea
          className="form-control form-control-lg rounded-3"
          rows="2"
          placeholder="Ej: Entregar en portería"
          value={instrucciones}
          onChange={(e) => { setInstrucciones(e.target.value); e.target.setCustomValidity(''); }}
          onInvalid={(e) => e.target.setCustomValidity('Por favor, complete este campo.')}
        />
      </div>

      <button 
        type="submit" 
        className="btn btn-primary btn-lg w-100 rounded-pill shadow-sm mt-3"
      >
         Procesar compra
      </button>
    </form>
  </div>
);

export default DeliveryForm;
